module.exports = __webpack_public_path__ + "img/GoblinFemale_Light.5c4fbd97.png";